<template>
    <div class="achieve" id="achieve">
       <!-- 我的成就 -->
       <div class="content">
         <div class="info">
           <div class="user">
             <img :src="userinfo.photoUrl || require('../../assets/images/head.png')" alt="">
             <span class="name">{{detail.traineeName}}</span>
           </div>
           <div class="detail">
             <div class="top">
               <img class="time" src="../../assets/images/achieve_time.png" alt="">
               <span class="num">我的学时:{{durationRate}}</span>
               <!-- <img class="rank" src="../../assets/images/achieve_rank_.png" alt=""> -->
               <!-- <span class="num">我的排名:{{detail.order}}</span> -->
             </div>
             <div class="bottom">
               <span class="list">发布讨论:{{detail.totalGuestBook}}</span>
               <span class="list">收获点赞:{{detail.reveiveUps}}</span>
               <span class="list">送出点赞:{{detail.sendUps}}</span>
             </div>
             <div class="status" v-if="detail.status == 2">
               <img src="../../assets/images/achieve_ok.png" alt="">
             </div>
           </div>
         </div>
         <div style="clear: both;"></div>
         <div class="table">
           <table>
             <tr>
               <td class="name">课程名称</td>
               <td class="time">学时</td>
               <td class="point">知识点</td>
               <td class="step">学习进度</td>
               <td class="rank">测评得分</td>
             </tr>
             <tr v-for="(item,index) in courseList" :key="index">
               <td class="name">{{item.courseName}}</td>
               <td class="time">{{item.coursePeriod}}</td>
               <td class="point">{{item.total}}</td>
               <td class="step">{{item.done}}/{{item.total}}</td>
               <td class="rank">{{item.score}}</td>
             </tr>
           </table>
         </div>
       </div>
    </div>
</template>

<script>
  export default {
    name: 'achieve',
    data () {
      return {
        event:'',
        userinfo:'',
        courseDuration:'',
        courseList:'',
        traineeDuration:'',
        detail:'',
        durationRate:0,
      }
    },
    mounted() {
      this.event = JSON.parse(localStorage.getItem('event'));
      console.log(this.enent);
      this.getData();
      this.userinfo = JSON.parse(localStorage.getItem('userinfo'));
    },
    methods:{
      getData(){
        var _this = this;
        var params = {
          eventId:_this.event.eventId,
        }
        this.post('/trainee/achievement',params,(data)=>{
          console.log(data);
          if(data.status == 200){
            _this.detail = data.data;
            _this.courseDuration = data.data.courseDuration;
            _this.courseList = data.data.courseList;
            _this.traineeDuration = data.data.traineeDuration;
            _this.durationRate = data.data.durationRate;
          }
        })
      },
    }
  }
</script>
<style scoped>
.table{
  width: 100%;
  padding-top: 0.84rem;
}
table{
  width: 13.4rem;
  max-width: 100%;
  margin: 0.1rem auto;
  border:solid #6e6e6e;
  border-width:2px 0px 0px 2px;
}
td{
  font-size: 0.25rem;
  color: #6e6e6e;
  border:solid #6e6e6e;
  border-width:0px 2px 2px 0px;
  padding: 0.12rem 0;
  text-align: center;
}
td.name{
  width: 3.9rem;
}
td.time{
  width: 2.24rem;
}
td.point{
  width: 2.24rem;
}
td.step{
  width: 2.24rem;
}
td.rank{
  width: 2.5rem;
}
.content{
  width: 15rem;
  max-width: 100%;
  margin: 0 auto;
}
.info{
  width: 100%;
}
.info .user{
  width: 1.38rem;
  float: left;
  width: 4.7rem;
}
.info .user img{
  float: left;
  width: 1.38rem;
  height: 1.38rem;
  margin: 0.8rem 0 0 1.65rem;
}
.info .user .name{
  width: 100%;
  float: left;
  font-size: 0.33rem;
  color: #181818;
  text-align: center;
  margin-top: 0.2rem;
}
.detail{
  width: 9.5rem;
  max-width: 100%;
  float: left;
  position: relative;
}
.detail .top{
  float: left;
  width: 100%;
  height: 0.5rem;
  line-height: 0.5rem;
  margin-top: 1rem;
}
.detail .top .time{
  width: 0.38rem;
  height: 0.41rem;
  float: left;
}
.detail .top .num{
  font-size: 0.33rem;
  height: 0.33rem;
  line-height: 0.33rem;
  color: #414141;
  float: left;
  margin: 0.06rem 0.8rem 0 0.1rem;
}
.detail .top .rank{
  width: 0.4rem;
  height: 0.45rem;
  float: left;
}
.detail .bottom{
  width: 100%;
  height: 0.3rem;
  line-height: 0.3rem;
  float: left;
  margin-top: 0.98rem;
}
.detail .bottom .list{
  float: left;
  font-size: 0.25rem;
  color: #414141;
  margin-right: 1.1rem;
}
.status{
  width: 1.98rem;
  height: 1.73rem;
  position: absolute;
  right: 0;
  top: 0.8rem;
}

</style>



// WEBPACK FOOTER //
// src/components/index/Achieve.vue